import React from 'react'
import "./ReviewVideomodal.css"
import Modal from 'react-bootstrap/Modal';
const ReviewVideomodal = (props) => {

    const isVideo = typeof props?.image === "string" &&
    (props.image.endsWith(".mp4") ||
     props.image.endsWith(".webm") ||
     props.image.endsWith(".avi"));



    return (
        <>
            <section>
                <Modal
                    {...props}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className='ReviewModalvideo'
                >

                    <Modal.Body>

                        {isVideo ? (
                            <video
                                autoPlay
                                muted
                                loop
                                controls
                                className="videoModal"
                            >
                                <source
                                    src={props?.image}
                                    type="video/mp4"
                                />
                                Your browser does not support the video tag.
                            </video>
                        ) : (
                            <img
                                src={props?.image}
                                alt="review"
                                className="videoModal"
                            />
                        )}

                        {/* <img src={props?.image} className='videoModal'/> */}
                        {/* <video src={process.env.PUBLIC_URL + "/assest/video/revieVideo.mp4"} muted controls loop autoPlay className='videoModal'></video> */}
                    </Modal.Body>

                </Modal>
            </section>
        </>
    )
}

export default ReviewVideomodal